import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckInput from 'screens/components/basic/CheckInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import { Archive as ArchiveIcon } from '@mui/icons-material';

const componentName = "CategorySales";

const IsCannabis = [
    {
        text: "All", value: "2"
    },
    {
        text: "Cannabis", value: "1"
    },
    {
        text: "Non-Cannabis", value: "0"
    }
];

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    defaultValue={"2"}
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={IsCannabis}
                />
            </div> {/* .col */}

            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}

            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <SelectInput
                    defaultValue={"Day"}
                    name={componentName + "ReportBy"}
                    fullWidth={true}
                    label={"Report By*"}
                    floatingLabelText={"Report By*"}
                    hintText={"Report By*"}
                    options={props.group && props.group.length > 0 ? props.group : []}
                />
            </div>
            <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <CheckInput
                    name={componentName + "IncludeProducts"}
                    text="Include Product Summary in CSV"
                    className="checkBoxLabels"
                />

            </div>
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-5 col-xl-8 mt-0 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    icon={<ArchiveIcon />}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders' net sale value will be used in this report.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
